import type { SVGProps } from "react";
export interface EmailReadingHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EmailReadingHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EmailReadingHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.375 11.5V5c0-1.036-.84-1.875-1.875-1.875h-9c-1.036 0-1.875.84-1.875 1.875v6.5a1.125 1.125 0 0 1-2.25 0V5A4.125 4.125 0 0 1 7.5.875h9A4.125 4.125 0 0 1 20.625 5v6.5a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="m20.875 11.987-6.753 4.052a4.12 4.12 0 0 1-3.995.137l-.25-.137-6.752-4.054v7.016c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.874-.84 1.875-1.875zm-7.199-7.61c.858 0 1.595.44 2.083 1a3.18 3.18 0 0 1 .788 2.173l.002.001c-.033 1.112-.689 1.955-1.264 2.552l-.24.242c-.42.412-.824.794-1.172 1.117l-.843.77a1.54 1.54 0 0 1-1.95.092l-.114-.092c-.4-.36-1.173-1.064-2.015-1.887-.616-.602-1.465-1.523-1.503-2.794V7.55a3.18 3.18 0 0 1 .79-2.174c.488-.56 1.224-.999 2.082-.999.726 0 1.271.24 1.678.548a2.7 2.7 0 0 1 1.678-.548m0 2.25a.5.5 0 0 0-.39.15q-.084.083-.149.191l-.126.24-.055.102a1.125 1.125 0 0 1-1.448.422 1.1 1.1 0 0 1-.52-.528l-.003.003c-.083-.172-.162-.32-.275-.43a.5.5 0 0 0-.39-.15c-.07 0-.225.044-.386.229a.97.97 0 0 0-.225.462l-.011.163v.003l.011.113c.053.27.275.61.815 1.138l1.132 1.08q.182.167.342.312c.399-.366.923-.852 1.475-1.392l.212-.215c.452-.477.606-.782.614-1.036v-.003l-.012-.163a.97.97 0 0 0-.224-.462c-.162-.185-.317-.229-.387-.229m9.449 12.374A4.125 4.125 0 0 1 19 23.126H5A4.126 4.126 0 0 1 .875 19v-7.235c0-1.548 1.584-2.542 2.949-1.96l.27.137 6.941 4.167a1.88 1.88 0 0 0 1.93 0l6.941-4.167.27-.137c1.365-.582 2.948.411 2.949 1.96V19Z"
      />
    </svg>
  );
}
